import { Box, IconButton } from '@mui/material';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

export const IconButtonStyle = styled(IconButton)(
  ({ theme }) => `
  .icon {
    stroke: #ebebeb;
    stroke-width: 1px;
    color: transparent;
  }
  ${theme.breakpoints.down('md')} {
    svg {
      width: 24px;
    }
    .icon.share {
      width: 20px;
    }
  }
  .icon.social {
    width: 22px;
    height: 22px;
    color: ${theme.palette.primary.main};
  }
`,
);

export const SocialBox = styled(Box)(`
  border-left: 1px solid rgba(0, 0, 0, 0.12);
  margin: 8px 4px;
`);

export const LightTooltip = styled(({ className, ...props }: any) => (
  <ClickAwayListener onClickAway={props.onClose}>
    <Box sx={{ display: 'inline' }}>
      <Tooltip {...props} classes={{ popper: className }} />
    </Box>
  </ClickAwayListener>
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
  },
  [`& .${tooltipClasses.tooltipPlacementBottom}`]: {
    marginTop: '6px !important',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: 'white',
  },
}));
